import { createFileRoute, redirect } from "@tanstack/react-router";
import AppCard from "@components/AppCard.tsx";
import {
  Stack,
  Typography,
  Button,
  TextField,
  MenuItem,
  Tab,
  Box,
} from "@mui/material";
import { useEnums } from "@/store/hooks.ts";
import Select from "@mui/material/Select";
import ModulesStatusChip from "@components/modules/ModulesStatusChip.tsx";
import CampaignStatusChip from "@components/campaigns/CampaignStatusChip.tsx";
import ParticipationStatusChip from "@components/modules/participations/ParticipationStatusChip.tsx";
import { AppTabList } from "@components/AppTabList.tsx";
import { TabContext } from "@mui/lab";
import AppAvatar from "@components/AppAvatar.tsx";
import { useSession } from "@hooks/useSession.tsx";
import { useState } from "react";
import AppDrawer from "@components/AppDrawer.tsx";
import { NavigationButton } from "@components/navigation/NavigationButton.tsx";
import Loader from "@components/Loader.tsx";
import ParticipationsDataGrid from "@components/participations/ParticipationsDataGrid.tsx";
import ModulesDataGrid from "@components/modules/datagrid/ModulesDataGrid.tsx";

export const Route = createFileRoute("/showcase/")({
  component: RouteComponent,
  loader: ({ context }) => {
    if (!context.session?.isAuthenticated || !context.session.user) {
       
      throw redirect({
        to: "/login",
      });
    }
  },
});

function RouteComponent() {
  const { moduleStatuses, campaignStatuses, participationStatuses } =
    useEnums();
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const [tabValue, setTabValue] = useState("three");
  const session = useSession();

  return (
    <>
      <Stack spacing={4} bgcolor={"background.default"} padding={2}>
        <AppCard>
          <Stack spacing={2}>
            <Typography variant={"h1"}>
              H1 : Voyez ce koala fou qui mange des journaux et des photos dans
              un bungalow
            </Typography>
            <Typography variant={"h2"}>
              H2 : Voyez ce koala fou qui mange des journaux et des photos dans
              un bungalow
            </Typography>
            <Typography variant={"h3"}>
              H3 : Voyez ce koala fou qui mange des journaux et des photos dans
              un bungalow
            </Typography>
            <Typography variant={"body1"}>
              Body1 : Voyez ce koala fou qui mange des journaux et des photos
              dans un bungalow
            </Typography>
            <Typography variant={"body2"}>
              Body2 : Voyez ce koala fou qui mange des journaux et des photos
              dans un bungalow
            </Typography>
            <Typography variant={"caption"}>
              Caption : Voyez ce koala fou qui mange des journaux et des photos
              dans un bungalow
            </Typography>
            <Typography>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur
              porttitor imperdiet nulla. Aliquam mattis turpis ex, eget
              vulputate enim porta a. Nam odio orci, finibus vitae congue ut,
              convallis et ligula. Nullam sit amet finibus magna. Cras auctor,
              erat sit amet ullamcorper egestas, nisl urna venenatis mi, vel
              vehicula dui urna non nisl. Suspendisse erat mi, ultricies at
              convallis at, tempus in dolor. Maecenas auctor iaculis tortor eu
              euismod. In feugiat ipsum pellentesque iaculis sodales. Mauris
              libero tellus, dignissim quis ultrices sed, bibendum id risus.
              Suspendisse congue ex scelerisque, tempor dolor placerat,
              consectetur arcu. Donec commodo mollis congue. Cras non sem
              consequat, gravida quam vitae, feugiat purus. Curabitur ac ligula
              quam. Suspendisse eu elit non nunc imperdiet pharetra. Praesent
              interdum ornare velit, finibus tincidunt nulla ultricies ut. Cras
              at sapien elit. Nunc efficitur ac ipsum sit amet mollis. Cras
              porta odio eget est volutpat hendrerit. In pulvinar facilisis
              velit, id pretium massa vulputate non. Suspendisse ac pulvinar
              ante. Nunc mollis eros ipsum. Phasellus eleifend arcu nec velit
              aliquet, a interdum turpis lobortis. Mauris massa massa, vulputate
              vel efficitur ut, tempor non justo. Duis nibh metus, efficitur a
              neque sit amet, lacinia ullamcorper magna. Pellentesque et sapien
              non lacus luctus porta. Vivamus euismod sapien vel efficitur
              egestas. Interdum et malesuada fames ac ante ipsum primis in
              faucibus. Nullam at quam feugiat, sagittis erat at, interdum ex.
              Fusce condimentum purus at elit dignissim congue. Sed scelerisque
              vel massa non vehicula. Quisque non quam scelerisque felis maximus
              hendrerit vel vel nisi. Cras tempus venenatis dui, id blandit erat
              cursus et. Aenean sit amet ullamcorper enim, non tristique nunc.
            </Typography>
          </Stack>
        </AppCard>
        <Stack direction={"row"} spacing={1}>
          <Button variant={"contained"} onClick={() => setIsDrawerOpen(true)}>
            Contained
          </Button>
          <Button variant={"outlined"}>Outlined</Button>
          <Button variant={"text"}>Text</Button>
          <Button variant={"navigation"}>Navigation</Button>
          <Button disabled>Disabled</Button>
          <Button loading={true}>Loading</Button>
        </Stack>
        <Loader />
        <Stack direction={"row"} spacing={1}>
          <TextField
            variant={"filled"}
            placeholder={"Ecrire..."}
            label={"Filled"}
          />
          <TextField
            variant={"outlined"}
            placeholder={"Ecrire..."}
            label={"Outlined"}
          />
          <TextField
            variant={"standard"}
            placeholder={"Ecrire..."}
            label={"Standard"}
          />
        </Stack>
        <Stack direction={"row"} spacing={1}>
          <TextField variant={"filled"} placeholder={"Ecrire..."} />
          <TextField variant={"outlined"} placeholder={"Ecrire..."} />
          <TextField variant={"standard"} placeholder={"Ecrire..."} />
        </Stack>
        <Stack direction={"row"} spacing={1}>
          <Typography color={"text.primary"}>Campagnes</Typography>
          <Select<string[]>
            multiple
            size={"small"}
            value={[""]}
            sx={{
              flex: 1,
            }}
          >
            <MenuItem disabled value={""}>
              Statut
            </MenuItem>
            {moduleStatuses.map((status) => (
              <MenuItem key={status["@id"]} value={status.value.toString()}>
                <ModulesStatusChip size="small" status={status} />
              </MenuItem>
            ))}
          </Select>
        </Stack>
        <Stack direction={"row"} spacing={1}>
          <Typography color={"text.primary"}>Modules</Typography>
          <Select<string[]>
            multiple
            size={"small"}
            value={[""]}
            sx={{
              width: 250,
              flexShrink: 0,
            }}
          >
            <MenuItem disabled value={""}>
              Statut
            </MenuItem>
            {campaignStatuses.map((status) => (
              <MenuItem key={status["@id"]} value={status.value.toString()}>
                <CampaignStatusChip size="small" status={status} />
              </MenuItem>
            ))}
          </Select>
        </Stack>
        <Stack direction={"row"} spacing={1}>
          <Typography color={"text.primary"}>Participations</Typography>
          <Select<string[]>
            multiple
            size={"small"}
            value={[""]}
            sx={{
              flex: 1,
            }}
          >
            <MenuItem disabled value={""}>
              Statut
            </MenuItem>
            {participationStatuses.map((status) => (
              <MenuItem key={status["@id"]} value={status.value.toString()}>
                <ParticipationStatusChip status={status} />
              </MenuItem>
            ))}
          </Select>
        </Stack>
        <Stack direction={"row"} spacing={1}>
          <AppAvatar fullName={session!.user.fullName} />
        </Stack>
        <TabContext value={tabValue}>
          <AppTabList onChange={(e, newValue: string) => setTabValue(newValue)}>
            <Tab label={"One"} value={"one"} />
            <Tab label={"Two"} value={"two"} />
            <Tab label={"Three"} value={"three"} />
          </AppTabList>
        </TabContext>
        <Stack spacing={1} maxWidth={"200px"}>
          <NavigationButton
            item={{
              label: "Showcase",
              icon: "tabler:table",
              href: "/showcase",
            }}
          />
          <NavigationButton
            item={{
              label: "Home",
              icon: "tabler:home",
              href: "/home",
            }}
          />
        </Stack>
        <AppCard title={"Participations"}>
          <ParticipationsDataGrid />
        </AppCard>
      </Stack>
      <AppDrawer open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)}>
        <Box>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin
          pharetra dui mi, vitae egestas ipsum posuere sed. Vivamus eu cursus
          enim. Quisque fringilla diam sed velit maximus, et ultricies ipsum
          condimentum. Integer consequat leo odio, eu commodo justo pretium
          efficitur. Phasellus eu rhoncus velit. Nulla metus arcu, vehicula quis
          neque vitae, bibendum blandit quam. Maecenas ut enim nec quam viverra
          porta mattis nec diam. Fusce commodo leo est, nec bibendum justo
          pretium eget. Mauris tempus bibendum nibh, at rhoncus tellus efficitur
          in. Donec nec ligula ut enim vehicula fermentum eget a purus. Vivamus
          at metus molestie, dapibus ante in, fermentum quam. Donec sapien
          lectus, aliquam ac dictum sit amet, fermentum ut massa. Aliquam
          viverra arcu in nibh iaculis, quis blandit eros aliquam. Aliquam
          elementum id urna ac luctus. Phasellus scelerisque blandit nisl, non
          semper erat. Suspendisse potenti. Fusce eget ante at neque sodales
          porttitor sit amet sed enim. In hac habitasse platea dictumst. In
          posuere dictum lacus nec aliquam. Nulla bibendum bibendum urna ut
          tempus. Morbi at libero cursus, convallis enim eu, interdum magna.
          Suspendisse auctor, leo a congue molestie, quam leo efficitur sapien,
          eget gravida sapien ex a sem. Duis porta sem vel porta gravida. Sed
          risus mauris, semper ut pellentesque quis, imperdiet ac nibh. Etiam
          auctor facilisis nisi, et molestie turpis tincidunt at. Nulla at mi
          gravida, laoreet massa eu, sagittis turpis. Etiam ac turpis at mauris
          iaculis facilisis. Donec laoreet neque sed leo scelerisque, nec
          aliquet metus tincidunt. Sed ut nunc justo. Vivamus cursus non orci
          luctus bibendum. Cras iaculis maximus eros sit amet interdum. Donec
          varius a nisi a faucibus. Suspendisse suscipit vehicula nibh. Praesent
          id eleifend massa. Quisque molestie semper nisi ac sagittis. Cras
          posuere aliquam est, vitae gravida sapien consectetur in. Vestibulum
          ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia
          curae; Pellentesque ultricies augue velit, eget pulvinar orci
          porttitor at. Praesent faucibus tellus quis sodales mattis. Nulla
          placerat eget risus sed scelerisque. Praesent luctus at enim et
          vehicula. Donec imperdiet volutpat viverra. Nulla nisi magna,
          consequat ac neque accumsan, faucibus viverra tortor. Vestibulum nisi
          diam, scelerisque vel elementum a, sollicitudin ut justo. Ut laoreet
          eget velit quis laoreet. Etiam eros metus, elementum a imperdiet eget,
          tincidunt at lacus. Integer at nunc fermentum, dictum leo vel, ornare
          leo. Phasellus quis felis eleifend, efficitur eros at, commodo augue.
          Cras sit amet sapien lobortis, tempor felis sed, volutpat lorem.
          Mauris hendrerit eros ac lacinia malesuada. Cras fermentum, quam non
          pharetra mattis, ipsum nibh hendrerit felis, et laoreet massa diam
          lobortis ante. Maecenas bibendum odio vel dignissim facilisis. Sed
          semper ligula vel velit molestie tincidunt. Suspendisse non sagittis
          leo, in vehicula risus. Nulla aliquet in quam lacinia convallis.
          Mauris erat nulla, congue ac risus vitae, blandit aliquet dolor. Class
          aptent taciti sociosqu ad litora torquent per conubia nostra, per
          inceptos himenaeos. Aenean ultrices justo vitae lacus fermentum
          rutrum. Donec ultrices varius ornare. Aliquam rutrum tortor vitae
          lectus tempor consectetur. Nam laoreet gravida urna vitae condimentum.
          Quisque mollis eu nisl at tincidunt. Curabitur nulla est, mattis quis
          lectus sed, finibus pretium tellus. Sed ultrices, leo vel congue
          congue, dolor urna pharetra enim, in porta dui ex quis nunc. Nunc
          tincidunt ipsum ut est faucibus consectetur. Sed laoreet pulvinar
          molestie. Ut tincidunt ipsum gravida ligula bibendum, at tempus ante
          finibus. Nulla vel blandit tellus, accumsan auctor neque. Suspendisse
          laoreet quam quis lorem congue, non pharetra quam iaculis. Suspendisse
          potenti. Sed eget venenatis eros. Donec placerat, metus eget mollis
          tristique, sapien nisl euismod ipsum, eu tincidunt magna eros eu
          purus. In id odio et nisl viverra lacinia sed sed enim. Interdum et
          malesuada fames ac ante ipsum primis in faucibus. Proin ultricies,
          nibh euismod finibus condimentum, mi quam hendrerit eros, non tempor
          leo tellus sit amet libero. Orci varius natoque penatibus et magnis
          dis parturient montes, nascetur ridiculus mus. Mauris ultrices, massa
          eu facilisis lobortis, risus est ultricies elit, non pharetra nibh
          ante in sem. Sed imperdiet placerat faucibus. Sed rutrum tincidunt
          urna at tempor. Nunc arcu diam, ullamcorper et commodo at, malesuada
          vel eros. Duis porttitor scelerisque arcu, id gravida sem pellentesque
          sed. Proin et dictum leo. In gravida ante vitae justo tristique, ut
          lobortis lorem semper. Vivamus pretium finibus purus. Curabitur vel
          eros nisi. Quisque libero felis, blandit in nunc quis, molestie
          porttitor mauris. Vestibulum sed efficitur sapien, sit amet
          scelerisque velit. Sed a erat magna. Ut nec arcu sit amet orci maximus
          tincidunt a eget neque. Proin consectetur, dolor vel rutrum finibus,
          felis nibh gravida libero, eu cursus purus tortor nec augue. In nec
          risus sit amet felis hendrerit tincidunt. Ut et placerat quam, sed
          rutrum ante. Nam commodo quis tortor eu feugiat. In fringilla nulla
          nisi, non viverra orci vulputate vel. Morbi ullamcorper augue in porta
          vestibulum. Vivamus laoreet diam vitae sem rhoncus condimentum.
          Curabitur interdum consequat tempus. Donec semper, lacus semper
          finibus facilisis, dui risus faucibus libero, id pretium purus ligula
          non ipsum. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
          Pellentesque habitant morbi tristique senectus et netus et malesuada
          fames ac turpis egestas. Sed lacus lectus, mollis sed libero sed,
          varius ullamcorper est.
        </Box>
      </AppDrawer>
    </>
  );
}
